export default (params) => {
  // Получаем ссылку на элемент <html>
  const htmlElement = document.documentElement;
  const {
    params: { partner, template },
  } = params;

  // Добавляем CSS класс
  htmlElement.classList.add(`${partner}-${template}`);
};
